import {
  ContratosCorreccionPara,
  EstadoPreventaEnum,
  EstadosContratoChoiceEnum,
  gridSizeMdLg1,
  gridSizeMdLg6,
  ModulosEnumChoice,
} from "@/shared";
import {
  useFetchContratos,
  useFetchMotivosRechazo,
} from "@/shared/actions/erp";
import {
  CustomAutocompleteArrString,
  SingleIconButton,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { useTableColumnsPreventa } from "@/shared/hooks/useTableColumnsPreventa";
import { Contrato } from "@/shared/interfaces";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Grid } from "@mui/material";
import { ReactNode } from "react";
import { FieldError, useForm } from "react-hook-form";

type FormMotivosFiltro = {
  motivocorreccioncontrato: string;
};

export default function CheckInstalacionTecnicoPage() {
  //HOOK PERSONALIZADO
  const { columnsPlantaExternaContratosNovedades } = useTableColumnsPreventa(
    EstadoPreventaEnum.EN_ESPERA
  );

  const form = useForm<FormMotivosFiltro>({
    // defaultValues: {
    //   contratoState: EstadosContratoChoiceEnum.ALL,
    //   estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    // },
  });
  const watchedMotivoCorreccion = form.watch("motivocorreccioncontrato", "");
  const { errors } = form.formState;
  const {
    data: motivosCorreccionContrato,
    isLoading: isLoadingMotivosCorreccionContrato,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.CONTRATOS,
    page_size: 256,
    nombre: "TECNICO",
  });

  const { pagination, setPagination } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      estado_actualizacion_in: `${EstadosContratoChoiceEnum.SOLICITUD_CORRECCION},${EstadosContratoChoiceEnum.CORREGIDO}`,
      correccion_para_in: `${ContratosCorreccionPara.TECNICO},${ContratosCorreccionPara.VENTAS_TECNICO}`,
      order_by: "fecha_modificacion",
      order_up: true,
      ultimos_motivos_correccion: watchedMotivoCorreccion,
      ...filterObject,
    },
  });

  return (
    <SingleTableBoxScene
      title={"Pendiente Actualizar Técnico"}
      visibleReport={true}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ display: "flex" }}>
          {/* <CustomSearch
              enableSearch={false}
              onChange={onChangeFilter}
              value={globalFilter}
              text="por Identificacion"
              onChangeRangeDate={onChangeRangeDate}
              cleanFilter={cleanFilter}
            /> */}
          <CustomAutocompleteArrString
            size={gridSizeMdLg6}
            label="Motivo Corrección"
            name="motivocorreccioncontrato"
            control={form.control}
            defaultValue={form.getValues().motivocorreccioncontrato || ""}
            options={
              motivosCorreccionContrato?.data?.data
                ?.map((item) => item.nombre)
                ?.concat([""])!
            }
            isLoadingData={isLoadingMotivosCorreccionContrato}
            error={errors.motivocorreccioncontrato as FieldError}
            helperText={errors.motivocorreccioncontrato?.message as ReactNode}
            disableClearable
          />
          <SingleIconButton
            size={gridSizeMdLg1}
            startIcon={<FilterAltOffIcon />}
            onClick={() => {
              form.setValue("motivocorreccioncontrato", "");
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<Contrato>
            columns={columnsPlantaExternaContratosNovedades}
            data={contratosPagingRes?.data.data || []}
            isLoading={isLoadingContratos}
            isRefetching={isRefetchingContratos}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={contratosPagingRes?.data?.count}
            actionsColumnSize={120}
            canDelete={false}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            enableEditing={false}
          />
        </Grid>
      </Grid>
    </SingleTableBoxScene>
  );
}
